import MediaSection from "../../../components/forms/MediaSection";
import DecorationField from "../../../components/forms/DecorationField";
import { useImageValidation } from "../../../utils/useImageValidation";

import "../../works/api/WorkApi.css";

export default function BProjectForm({
  title,
  formData,
  files,
  videos,
  fileErrors,
  hasInvalidFiles,
  onChange,

  graphics,

  onVideoAdd,
  onVideoChange,
  onVideoRemove,  
  reorderVideos,

  onSubmit,
  submitText,
  loading = false
}) {
  const { registerValidation, hasInvalidImages } = useImageValidation();

  if (!formData || !files) return null;

  return (
    <form className="work-form" onSubmit={onSubmit}>
      <h2>{title}</h2>

      <h3>Título del Proyecto</h3>
      <input
        name="title"
        placeholder="Título del Proyecto"
        value={formData.title || ""}
        onChange={onChange}
        required
      />

      <h3>Descripción del Proyecto</h3>
      <textarea
        name="description"
        placeholder="Descripción del Proyecto"
        value={formData.description || ""}
        onChange={onChange}
      />

      <h3>Autor</h3>
      <select
        name="author"
        value={formData.author || ""}
        onChange={onChange}
        required
      >
        <option value="">Seleccionar autor</option>
        <option value="autor1">Ana Montesino</option>
        <option value="autor2">Agustina Lubris</option>
      </select>

      <h3>Estado</h3>
      <select
        name="status"
        value={formData.status || "draft"}
        onChange={onChange}
      >
        <option value="draft">Borrador</option>
        <option value="published">Publicado</option>
        <option value="archived">Archivado</option>
      </select>
      
      <DecorationField
        value={formData.decorations || []}
        onChange={decorations =>
          onChange({
            target: {
              name: "decorations",
              value: decorations
            }
          })
        }
      />

      <MediaSection
        imageArrays={[
          {
            title: "Imágenes",
            items: files.graphics,
            controls: {
              ...graphics,
              onValidationChange: registerValidation
            }
          }
        ]}
        /*
        videosConfig={{
          title: "URL de Videos (YouTube)",
          videos,
          onAdd: onVideoAdd,
          onChange: onVideoChange,
          onRemove: onVideoRemove,
          onReorder: reorderVideos
        }}
        */
      />

      <button type="submit" disabled={loading || hasInvalidFiles || hasInvalidImages} className="form-button">
        {loading ? "Procesando..." : submitText}
      </button>
    </form>
  );
}